module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    class: {
      'dark': _vm.bgType || _vm.dark
    }
  }, [_c('div', {
    staticClass: "header_wrap clear"
  }, [_c('div', {
    ref: "logo",
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/logo_01.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "lang clear"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.changeLang(1)
      }
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.changeLang(0)
      }
    }
  }, [_vm._v("CN")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.language) ? _c('span', [_c('a', {
    attrs: {
      "href": "http://vbs.vgtech.com.cn/"
    }
  }, [_vm._v("LOGIN")])]) : _c('span', [_c('a', {
    attrs: {
      "href": "http://vbs.vgtech.com.cn/"
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pcSearch),
      expression: "pcSearch"
    }],
    ref: "pcSearch",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.language == 1 ? 'SEARCH' : '请输入关键词'
    },
    domProps: {
      "value": (_vm.pcSearch)
    },
    on: {
      "focus": function($event) {
        return _vm.clearVal()
      },
      "blur": function($event) {
        return _vm.addVal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pcSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/search/' + this.pcSearch
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    ref: "menuList",
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group",
    on: {
      "click": _vm.close
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pcSearch),
      expression: "pcSearch"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.language == 1 ? 'SEARCH' : '请输入关键词'
    },
    domProps: {
      "value": (_vm.pcSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pcSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/search/' + this.pcSearch
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    }
  })])], 1)])]), _vm._v(" "), _c('ul', {
    ref: "menu",
    staticClass: "list clear"
  }, [_c('li', {
    staticClass: "list-item active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), (_vm.language) ? _c('span', [_vm._v("HOME")]) : _c('span', [_vm._v("首页")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), (_vm.language) ? _c('span', [_vm._v("SOLUTIONS")]) : _c('span', [_vm._v("解决方案")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "submenu",
    class: 'width10'
  }, [_c('ul', {
    staticClass: "sub_wrap clear"
  }, _vm._l((_vm.plan), function(item) {
    return _c('li', {
      staticClass: "sub_list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/solutionDetail/' + item.PlanId
        }
      }
    }, [_vm._v(_vm._s(item.PlanTitle))])], 1)
  }), 0)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), (_vm.language) ? _c('span', [_vm._v("PRODUCTS")]) : _c('span', [_vm._v("产品与服务")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "submenu",
    class: 'width' + _vm.product.length
  }, [_c('ul', {
    staticClass: "sub_wrap clear"
  }, _vm._l((_vm.product), function(item) {
    return _c('li', {
      staticClass: "sub_list"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/productDetail/' + item.ProductId
        }
      }
    }, [_vm._v(_vm._s(item.ProductTitle))])], 1)
  }), 0)])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/case"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), (_vm.language) ? _c('span', [_vm._v("CASE")]) : _c('span', [_vm._v("客户案例")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [(_vm.language) ? _c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("NEWS")])]) : _c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("资讯中心")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "submenu width2 fixed",
    staticStyle: {
      "width": "12rem"
    }
  }, [_c('ul', {
    staticClass: "sub_wrap clear"
  }, [_c('li', {
    staticClass: "sub_list"
  }, [(_vm.language) ? _c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("Latest News")]) : _c('router-link', {
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("新闻中心")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sub_list"
  }, [(_vm.language) ? _c('router-link', {
    attrs: {
      "to": "/discover"
    }
  }, [_vm._v("Industrial Insights")]) : _c('router-link', {
    attrs: {
      "to": "/discover"
    }
  }, [_vm._v("WE发现")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sub_list"
  }, [(_vm.language) ? _c('router-link', {
    attrs: {
      "to": "/news/8"
    }
  }, [_vm._v("Customer praise letter")]) : _c('router-link', {
    attrs: {
      "to": "/news/8"
    }
  }, [_vm._v("客户表扬信")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sub_list"
  }, [(_vm.language) ? _c('a', {
    attrs: {
      "href": "http://vbs.vgtech.com.cn/channel/"
    }
  }, [_vm._v("Channels To Recruit")]) : _c('a', {
    attrs: {
      "href": "http://vbs.vgtech.com.cn/channel/"
    }
  }, [_vm._v("渠道招募")])])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/about/one"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), (_vm.language) ? _c('span', [_vm._v("ABOUT US")]) : _c('span', [_vm._v("关于我们")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lang"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.changeLang(1);
      }
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('span', [_vm._v(" / ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.changeLang(0);
      }
    }
  }, [_vm._v("CN")])])]), _vm._v(" "), _c('div', {
    ref: "menuIcon",
    staticClass: "menu_icon clear",
    on: {
      "click": _vm.openMenu
    }
  }, [_c('span', {
    staticClass: "line lg"
  }), _vm._v(" "), _c('span', {
    staticClass: "line md"
  }), _vm._v(" "), _c('span', {
    staticClass: "line sm"
  })]), _vm._v(" "), _c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.openMenu
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b95fdaea"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 68
// module chunks = 15